<script lang="ts">
  import { _ } from 'svelte-i18n';
  import Carousel from '../Carousel.svelte';
  
  export let images: string[]
  export let video_id: string;
  export let height: number
  export let showScrollbar = true;
  export let showArrows = true;
  export let animate = true;
  export let faIconString: string | null = null;
  export let showNoGps: boolean = false;
  export let autoscroll_interval = 5000
  export let startAnimation = () => {};
  export let clearIntervals = () => {};
  
  $: imgHeight = "max-height: " + height + "px;"
  $: youtube_thumb = video_id ? `https://img.youtube.com/vi/${video_id}/hqdefault.jpg` : "";
  $: carousel_items = [...(images ?? []), youtube_thumb].filter(img => img);
</script>

{#if (carousel_items && carousel_items.length != 0)}
  <Carousel bind:startAnimation={startAnimation} bind:clearIntervals={clearIntervals} {animate} items={carousel_items} {showArrows} {showScrollbar} {autoscroll_interval} >
    <img class={url.includes("img.youtube.com") ? "youtube" : ""} slot="item" on:error={() => {carousel_items = carousel_items.filter(i => i!=url)}} let:item={url} style={imgHeight} alt={$_("sessions.alt.uploaded_image")} src={url}  />
  </Carousel>
{/if}


{#if !(carousel_items && carousel_items.length != 0) && faIconString}
    <div class='icon-container' style:height>
        <i class={`${faIconString} icon-pic`}></i>
    </div>
{:else if !(carousel_items && carousel_items.length != 0) && showNoGps}
    <img src="assets/images/nogps.png" alt="GPS data not available"/>
{/if}


<style lang="scss">
img {
  width: 100%;
  object-fit: contain;
}

img.youtube {
  object-fit: cover !important;
}
img.workout-img {
  max-width: 100%;
  max-height: 200px;
  align-self: center;
  width: 100%;
}
.icon-container {
  width: 100%;
  height: 100%;
  container-type: inline-size;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  padding-bottom: 24px;
}
.icon-pic {
  font-size: 26cqw;
  color: #888888;
}
</style>
